export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-popover/index.js